export function getTypeStatus(statusType: string) {
  if (statusType === 'MS1') {
    return {
      status: 'Pautas a definir',
      color: '#BDBDBD',
    };
  }
  if (statusType === 'MS2') {
    return {
      status: 'Pautas definidas',
      color: '#160B8C',
    };
  }
  if (statusType === 'MS3') {
    return {
      status: 'Pendente de ata',
      color: '#BDBDBD',
    };
  }
  if (statusType === 'MS4') {
    return {
      status: 'Ata inserida',
      color: '#FFB547',
    };
  }
  if (statusType === 'MS5') {
    return {
      status: 'Ata assinada',
      color: '#4CAF50',
    };
  }
  if (statusType === 'MS6') {
    return {
      status: 'Cancelada',
      color: '#d62237',
    };
  }
  return {
    status: 'Carregando',
    color: '#cecece',
  };
}

export function tituloFormatado(title: string) {
  const tituloSeparado = title.replace('-', ' ');

  return tituloSeparado[0].toUpperCase() + tituloSeparado.substring(1);
}
